import { FormGroup } from "@angular/forms";
import { addDays } from "date-fns";
import { RecurrencePattern } from "../../../shared/services/request.service";
var RecurrenceComponent = /** @class */ (function () {
    function RecurrenceComponent() {
        this.dayNames = ["M", "T", "W", "R", "F"];
    }
    Object.defineProperty(RecurrenceComponent.prototype, "recurrenceWeekInterval", {
        get: function () {
            return this.experimentDesignFormGroup.get("recurrenceWeekInterval");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecurrenceComponent.prototype, "recurrenceDays", {
        get: function () {
            return this.experimentDesignFormGroup.get("recurrenceDays");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecurrenceComponent.prototype, "recurrencePattern", {
        get: function () {
            return this.experimentDesignFormGroup.get("recurrencePattern");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecurrenceComponent.prototype, "recurrenceEndDate", {
        get: function () {
            return this.experimentDesignFormGroup.get("recurrenceEndDate");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecurrenceComponent.prototype, "minEndDate", {
        get: function () {
            return addDays(this.plantingDate, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecurrenceComponent.prototype, "maxEndDate", {
        get: function () {
            return addDays(this.plantingDate, 30);
        },
        enumerable: true,
        configurable: true
    });
    RecurrenceComponent.prototype.ngOnInit = function () {
        this.recurrenceNone = RecurrencePattern.None;
        this.recurrenceWeekly = RecurrencePattern.Weekly;
    };
    return RecurrenceComponent;
}());
export { RecurrenceComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/recurrence/recurrence.component.ts.pre-build-optimizer.js